import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

registerCardTemplate({
    id: 'heatmap',
    name: 'Heatmap',
    description: 'A heatmap to show 3-dimensional data',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-heatmap" */ "./HeatMapTemplate")),
    icon: generateIconProp('thLarge'),
    complexity: 'medium',
    preLoader: 'heatmap-chart',
    expectedSchema: 'dictionary-array',
    canDragDropFields: true,
});
